module.exports = __webpack_public_path__ + "img/MuayThaiChampion_Boxers.be64548a.png";